import { defineStore } from "pinia";
import { SettingSpec, settingsSpec } from "src/settings/SettingsSpec";
import { assertDefined } from "src/utils/Validation";

const localStorageKey = "settings";

export const useSettingsStore = defineStore("settings", {
  state: () => {
    function getSettingSpecByKey(key: string): SettingSpec<unknown> {
      return assertDefined(
        settingsSpec
          .flatMap((category) => category.settings)
          .find((setting) => setting.key == key),
      );
    }

    const settingKeys = settingsSpec
      .flatMap((category) => category.settings)
      .map((setting) => setting.key);
    return {
      settings: <ReadonlyMap<string, unknown>>(
        new Map<string, unknown>(
          JSON.parse(
            localStorage.getItem(localStorageKey) ||
              JSON.stringify(
                settingKeys.map((key) => [
                  key,
                  getSettingSpecByKey(key).defaultValue,
                ]),
              ),
          ),
        )
      ),
    };
  },

  actions: {
    updateEntry(key: string, value: unknown) {
      (this.settings as Map<string, unknown>).set(key, value);
      localStorage.setItem(
        localStorageKey,
        JSON.stringify(Array.from(this.settings.entries())),
      );
    },
  },
});
